import Cookies from "js-cookie";

import { auth } from "./firebase";
import { apiRequest } from "./utils/api";

/**
 * Espera a que Firebase sincronice el usuario y devuelve un ID token verificado.
 */
export async function waitForFirebaseTokenSync(idToken, maxWaitAttempts = 20) {
  let syncAttempts = 0;
  let tokenReady = false;
  let finalToken = idToken;

  while (syncAttempts < maxWaitAttempts && !tokenReady) {
    const currentUser = auth.currentUser;
    if (currentUser) {
      try {
        const verifiedToken = await currentUser.getIdToken(false);
        if (verifiedToken && verifiedToken.length > 0) {
          const parts = verifiedToken.split(".");
          if (parts.length === 3) {
            finalToken = verifiedToken;
            localStorage.setItem("token", verifiedToken);
            localStorage.setItem("authToken", verifiedToken);
            localStorage.setItem("iOS_token", verifiedToken);
            tokenReady = true;
            break;
          }
        }
      } catch (error) {
        console.warn(
          `⚠️ [AuthBootstrap] Esperando sincronización (intento ${syncAttempts + 1}/${maxWaitAttempts})...`
        );
      }
    }
    await new Promise((resolve) => setTimeout(resolve, 200));
    syncAttempts++;
  }

  if (!tokenReady) {
    console.warn("⚠️ [AuthBootstrap] No se pudo verificar el token después de sincronización");
    const parts = idToken.split(".");
    if (parts.length !== 3) {
      throw new Error(
        "El token de Firebase no tiene un formato válido. Por favor, intenta iniciar sesión nuevamente."
      );
    }
    finalToken = idToken;
  }

  return finalToken;
}

/**
 * Carga datos de usuario y empresa tras autenticarse con Firebase (mismo flujo que login normal).
 */
export async function bootstrapAuthenticatedSession() {
  const response = await apiRequest("/datos-usuario", {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error(`Error al obtener datos del usuario: ${response.status}`);
  }

  const userData = await response.json();

  if (userData.empresaId) {
    Cookies.set("empresaId", userData.empresaId);
    localStorage.setItem("empresaId", userData.empresaId);
  }
  if (userData.id) {
    localStorage.setItem("userId", userData.id);
    Cookies.set("userId", userData.id);
  }
  if (userData.firebase_uid) {
    localStorage.setItem("firebaseUid", userData.firebase_uid);
  }

  let empresaData = null;
  if (userData.empresaId) {
    try {
      const empresaResponse = await apiRequest(`/datos-empresa/${userData.empresaId}`, {
        method: "GET",
      });

      if (empresaResponse.ok) {
        empresaData = await empresaResponse.json();
        Cookies.set("empresaData", JSON.stringify(empresaData));
        localStorage.setItem("empresaData", JSON.stringify(empresaData));
      }
    } catch (error) {
      console.error("❌ [AuthBootstrap] Error al obtener datos de la empresa:", error);
    }
  }

  return { userData, empresaData };
}
